export default __webpack_public_path__ + "static/media/icon-otp-info.1030d848.svg";